<template>
  <div>
    <div class="row mb-3">
      <div class="col-12 col-md-8 col-lg-6">
        <a-image-card @show-dialog="showImageDialog = true" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageCard from "./components/image-card";

export default {
  components: {
    "a-image-card": ImageCard
  }
};
</script>
